<div class="w-full">
  <h3 class="title">Customizar Home da Mensmarket</h3>
  <div class="header-actions">
    <h4>
      Preview de stage:
      <a [href]="settings?.preview">{{ settings?.preview }}</a>
    </h4>
    <p-splitButton label="Atualizar" (onClick)="update()" [model]="menuItems" />
  </div>

  <div class="page-sections w-full">
    <h4>Seções adicionadas:</h4>

    <div
      cdkDropList
      [cdkDropListData]="sections"
      (cdkDropListDropped)="onDrop($event)"
      class="sections-list"
    >
      <div *ngFor="let section of sections; let i = index" class="mb-5" cdkDrag>
        <ng-container *ngIf="section.type === 'PLANS'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>Planos</h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-plans">
              <img class="fixed-image" [src]="'assets/images/plans.png'" />
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'SINGLE_PLAN'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>Plano único</h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-single-plan">
              <img
                class="fixed-image"
                [src]="'assets/images/single-plan.png'"
              />
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'BANNER'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Banner
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-banner">
              <p-carousel
                *ngIf="section.desktopImage; else emptyBanner"
                [value]="[section]"
                [numVisible]="1"
                [numScroll]="1"
              >
                <ng-template let-banner pTemplate="item">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 1rem;
                    "
                  >
                    <img
                      [src]="banner.desktopImage"
                      [alt]="banner.altText || section.title"
                      style="
                        width: 100%;
                        max-width: 100%;
                        height: 200px;
                        object-fit: contain;
                      "
                    />
                  </div>
                </ng-template>
              </p-carousel>

              <ng-template #emptyBanner>
                <div>Sem banner cadastrado</div>
              </ng-template>
            </div>

            <ng-template pTemplate="footer">
              <div class="section-displayRules">
                Regras de exibição:
                <p-chip
                  *ngFor="let ruleObj of section.displayRules"
                  [label]="mapDisplayRuleText(ruleObj)"
                  icon="pi pi-check"
                  styleClass="chip-true"
                >
                </p-chip>
              </div>
            </ng-template>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'HIGHLIGHTS'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Destaques
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-highlights">
              <p-carousel
                *ngIf="section.highlights?.length; else emptyHighlights"
                [value]="section.highlights"
                [numVisible]="6"
                [numScroll]="6"
              >
                <ng-template let-highlight pTemplate="item">
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: flex-start;
                      padding: 1rem;
                      text-align: center;
                    "
                  >
                    <img
                      [src]="highlight.image"
                      [alt]="highlight.altText || highlight.title"
                      style="
                        width: 100%;
                        max-width: 140px;
                        height: 140px;
                        object-fit: contain;
                      "
                    />
                    <span style="margin-top: 0.75rem; font-weight: 600">{{
                      highlight.title
                    }}</span>
                    <span style="margin-top: 0.25rem">{{
                      highlight.subtitle
                    }}</span>
                  </div>
                </ng-template>
              </p-carousel>

              <ng-template #emptyHighlights>
                <div>Sem destaques cadastrados</div>
              </ng-template>
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'COLLECTION'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Coleção:
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-collection">
              <p-carousel
                *ngIf="
                  productsByCategoryId[section.categoryId]?.length;
                  else collectionState
                "
                [value]="productsByCategoryId[section.categoryId]"
                [numVisible]="6"
                [numScroll]="6"
              >
                <ng-template let-product pTemplate="item">
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: flex-start;
                      padding: 1rem;
                      text-align: center;
                    "
                  >
                    <img
                      [src]="
                        product.images?.length
                          ? product.images[0]
                          : 'assets/images/no_img_available.jpg'
                      "
                      [alt]="product.name"
                      [style.opacity]="product.stock?.quantity < 1 ? 0.2 : 1"
                      style="
                        width: 100%;
                        max-width: 140px;
                        height: 140px;
                        object-fit: contain;
                      "
                    />
                    <span style="margin-top: 0.75rem; font-weight: 600">{{
                      product.brand
                    }}</span>
                    <span style="margin-top: 0.25rem">{{ product.name }}</span>
                    <p-badge
                      [value]="'Sem estoque'"
                      severity="danger"
                      *ngIf="product.stock?.quantity < 1"
                    />
                    <p-badge
                      [value]="'Em estoque'"
                      severity="success"
                      *ngIf="product.stock?.quantity > 0"
                    />
                  </div>
                </ng-template>
              </p-carousel>

              <ng-template #collectionState>
                <div *ngIf="loadingProductsByCategoryId[section.categoryId]">
                  Carregando produtos...
                </div>
                <div *ngIf="!loadingProductsByCategoryId[section.categoryId]">
                  Sem produtos cadastrados
                </div>
              </ng-template>
            </div>

            <ng-template pTemplate="footer">
              <div class="section-displayRules">
                Regras de exibição:
                <p-chip
                  *ngFor="let ruleObj of section.displayRules"
                  [label]="mapDisplayRuleText(ruleObj)"
                  icon="pi pi-check"
                  styleClass="chip-true"
                />
              </div>
            </ng-template>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'BRANDS'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Marcas
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-brands">
              <p-carousel
                *ngIf="section.brands?.length; else emptyBrands"
                [value]="section.brands"
                [numVisible]="6"
                [numScroll]="6"
              >
                <ng-template let-brand pTemplate="item">
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      padding: 1rem;
                      text-align: center;
                    "
                  >
                    <img
                      [src]="
                        brand.image || 'assets/images/no_img_available.jpg'
                      "
                      [alt]="brand.brandName"
                      style="
                        width: 100%;
                        max-width: 120px;
                        height: 120px;
                        object-fit: contain;
                      "
                    />
                    <span style="margin-top: 0.75rem">{{
                      brand.brandName
                    }}</span>
                  </div>
                </ng-template>
              </p-carousel>

              <ng-template #emptyBrands>
                <div>Sem marcas cadastradas</div>
              </ng-template>
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'CAROUSEL'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Carrossel de banners
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-carousel">
              <p-carousel
                *ngIf="section.banners?.length; else emptyCarousel"
                [value]="section.banners"
                [numVisible]="1"
                [numScroll]="1"
              >
                <ng-template let-banner pTemplate="item">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 1rem;
                    "
                  >
                    <img
                      [src]="banner.desktopImage"
                      [alt]="banner.altText || section.title"
                      style="
                        width: 100%;
                        max-width: 100%;
                        height: 200px;
                        object-fit: contain;
                      "
                    />
                  </div>
                </ng-template>
              </p-carousel>

              <ng-template #emptyCarousel>
                <div>Sem banners cadastrados</div>
              </ng-template>
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'NEWSLETTER'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Newsletter
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-newsletter">
              <img class="fixed-image" [src]="'assets/images/newsletter.png'" />
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'INFOBARS'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Infobars
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>

            <div class="section-infobars">
              <p-carousel
                *ngIf="section.infobars?.length; else emptyInfobars"
                [value]="section.infobars"
                [numVisible]="1"
                [numScroll]="1"
              >
                <ng-template let-infobar pTemplate="item">
                  <div style="padding: 1rem">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        min-height: 96px;
                        padding: 1rem;
                        text-align: center;
                        border: 1px solid #e5e7eb;
                        border-radius: 6px;
                      "
                    >
                      <span>{{ infobar.text }}</span>
                    </div>
                  </div>
                </ng-template>
              </p-carousel>

              <ng-template #emptyInfobars>
                <div>Sem infobars cadastradas</div>
              </ng-template>
            </div>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'BEAUTY_PROFILE_COLLECTION'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>Coleção de Perfil de Beleza</h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'SUBSCRIBER_INFO'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Informação de assinatura
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-card>
        </ng-container>

        <ng-container *ngIf="section.type === 'LIVE'">
          <p-card class="w-full section-item">
            <ng-template pTemplate="header">
              <div class="card-header-layout">
                <h3>
                  Live:
                  <span *ngIf="section.title">{{ section.title }}</span>
                </h3>
                <div>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrows-alt"
                    class="p-button-text p-button-rounded p-mr-2"
                    pTooltip="Arrastar para reordenar"
                    *ngIf="!section.fixed"
                    cdkDragHandle
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-info"
                    pTooltip="Editar seção"
                    (click)="editSection(i)"
                    [disabled]="!section.editable"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger"
                    pTooltip="Remover seção"
                    (click)="removeSection(i)"
                    [disabled]="section.fixed"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-card>
        </ng-container>
      </div>
    </div>
  </div>
</div>
